<h2 mat-dialog-title>
  <mat-icon aria-hidden="true">notifications_active</mat-icon>
  {{ 'notifications.intro.title' | translate }}
</h2>

<mat-dialog-content>
  <p>{{ 'notifications.intro.body' | translate }}</p>
  <p>{{ 'notifications.intro.settings-hint' | translate }}</p>
</mat-dialog-content>

<mat-dialog-actions align="end">
  <button
    mat-raised-button
    color="primary"
    (click)="onDismiss()"
    data-testid="notification-intro-dismiss"
  >
    {{ 'notifications.intro.dismiss' | translate }}
  </button>
</mat-dialog-actions>
